import React from 'react';
import ContainerDefault from '../../../Componant/DashBoard/Default';

const Default = () => {
  return (
    <div className='page-body'>
      <ContainerDefault />
    </div>
  );
};

export default Default;
